import React from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  imageUrl: any;
  _id: string;
  firstName: string;
  lastName: string;
  role: string;
};

function UserCard(props: Props) {
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-lg shadow-lg flex flex-col space-y-5 w-full p-5 justify-center">
      <img className="w-24 h-24 rounded-full m-auto" src={props.imageUrl} />
      <p className="font-semibold text-grey-dark text-center">{`${props.firstName} ${props.lastName}`}</p>
      <p className="text-center">{props.role}</p>
      <button
        className="rounded-lg text-white bg-aqua py-2 px-5"
        onClick={() => navigate(`/profile/${props._id}`)}
      >
        Profiel
      </button>
    </div>
  );
}

export default UserCard;
